// extracted by mini-css-extract-plugin
module.exports = {"observadorBotoInserir":"Observador_observadorBotoInserir__1bQod","observadorSpinner":"Observador_observadorSpinner__rXvPj"};